module.exports = __webpack_public_path__ + "ad88044d48d7c401d3bec290c5048a0b.svg";